import React from 'react';
import LoginPage from '@monorepo/auth/pages/LoginPage';

// Oddisignals logo component
const OddisignalsLogo = () => (
  <h1 className="text-h4 text-ink">
    oddsignals<span className="text-ink-subtle">.ai</span>
  </h1>
);

// Oddisignals-specific branding
const oddsignalsBranding = {
  logo: <OddisignalsLogo />,
  subtitle: 'Sign in to manage your social accounts',
  backgroundColor: 'bg-canvas',
  cardBackground: '',
  // Fill and label both come from <Button variant="primary">; overriding only
  // one half here is what previously produced white-on-white.
  primaryColor: '',
  textColor: 'text-ink',
  subtitleColor: 'text-ink-muted',
  inputStyle:
    'block w-full min-h-[var(--tap-target)] rounded-field px-3.5 py-2.5 ' +
    'bg-surface-sunken border border-line text-ink placeholder:text-ink-subtle ' +
    'focus:outline-none focus:border-accent focus:bg-surface transition-colors',
  defaultRedirect: '/dashboard',
};

const Login = () => {
  return <LoginPage branding={oddsignalsBranding} />;
};

export default Login;
